import React from 'react';
import styled from 'styled-components';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Avatar,
  Stack,
  Badge,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { NotificationsNoneOutlined, Person } from '@mui/icons-material';

import { ThemeContext } from '@tiui/remote.gfi.providers.theme';

type avatarItem = {
  title: string;
  link: string;
  onClick?: () => void;
};

export type HeaderProps = {
  /**
   * @description Menu items to be shown when user avatar is clicked
   * @example
   * avatarItems: [
   *  {title: "Profile", link: "/profile"}.
   *  {title: "Logout", link: "/logout"}
   * ]
   */
  avatarItems?: avatarItem[];

  avatarImage?: React.ReactNode;
  /**
   * @description The number of notifications to be displayed on top of the badge
   * @default 0
   */
  notifications?: number;
  /**
   * The logo to be used. Preferably pass a tiui BaseImage component, but any other image will also do eg <img src="logo.png" alt="logo" />
   */
  logo: React.ReactNode;
};

const Container = styled.div`
  flex-grow: 0;

  div.MuiToolbar-root {
    button.MuiButtonBase-root:not(:first-child) {
      margin-left: 2px;
    }
  }
`;

export function Header({
  avatarItems = [{ title: 'Logout', link: '#logout' }],
  notifications = 0,
  avatarImage,
  logo,
}: HeaderProps) {
  const theme = React.useContext(ThemeContext);
  console.log('HEADER:::THEME', theme);

  const [anchorElUser, setAnchorElUser] =
    React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Container>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: `${theme?.primaryContrast} !important`,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: '0px 4px 4px -1px rgba(31, 31, 31, 0.05)',
        }}
        id="headerBar"
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>{logo}</Box>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <IconButton size="large" onClick={null}>
              <Badge badgeContent={notifications} color="primary">
                <NotificationsNoneOutlined color="disabled" />
              </Badge>
            </IconButton>
            <IconButton onClick={handleOpenUserMenu}>
              <Avatar>{avatarImage || <Person />}</Avatar>
            </IconButton>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {avatarItems.map((item: avatarItem) => (
                <MenuItem
                  key={item.title}
                  href={item.link}
                  onClick={() => {
                    handleCloseUserMenu();
                    item.onClick && item.onClick();
                  }}
                >
                  <Typography textAlign="center">{item.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Stack>
        </Toolbar>
      </AppBar>
    </Container>
  );
}
